import React from 'react';
import { Label, ZipField, ErrorMessage } from '../FormikCustom';

export default function ZipCode({ name, label, required, forceError, ...rest }) {

    let className = 'form-control';
    if (forceError)
        className += ' error';

  return (
    <div className="form-group">
      <Label required={required} htmlFor={name}>{label}</Label>
          <ZipField name={name}  {...rest} className={className} />
          <ErrorMessage name={name} />
    </div>
  );
}
